import { render, staticRenderFns } from "./dataprint.vue?vue&type=template&id=bfa0d832&"
import script from "./dataprint.vue?vue&type=script&lang=js&"
export * from "./dataprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports